import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fm9b27ve2d: FaireBrandEntity = {
  token: "b_fm9b27ve2d",
  type: "brand",
  name: "The Find Peaks",
  avatarUrl:
    "https://cdn.faire.com/fastly/aea21e7b78da189a9d64f2a97b1c5c4fd87d8ad8bd6f57cab8ece37222884b1b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/40e45ab343d68fcd7b9a2ffff88cfd37a8bdf0fdb9081bcb368cf0df164bf797.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aea21e7b78da189a9d64f2a97b1c5c4fd87d8ad8bd6f57cab8ece37222884b1b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/40e45ab343d68fcd7b9a2ffff88cfd37a8bdf0fdb9081bcb368cf0df164bf797.jpeg",
  location: "Columbus, OH, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 6,
  isInsider: false,
  description:
    "Since our founding in 2025, TheFindPeaks has been dedicated to bringing premium kids’ fashion and lifestyle products to families around the world. We believe every child represents a peak of joy and potential — and deserves comfortable, stylish, and durable clothing. Over time, we’ve refined our offerings and customer experience to ensure every purchase feels special.\n\nTo help independent retailers and boutique shops discover our collections more easily, we’re proud to be part of Faire, a leading online wholesale marketplace that connects thousands of unique brands with retailers globally. Through Faire, we gain access to a wide network of stores and flexible purchasing options — empowering partners to stock our curated selection of kids’ fashion with confidence.\n\nJoining Faire marks a strategic step in growing our brand presence and building lasting retail partnerships. We look forward to collaborating with retailers worldwide to bring TheFindPeaks quality to families",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:53.832Z",
    importedBy: "entity-db-cli",
  },
};
